import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  FormHelperText,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Link,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Typography,
  Avatar,
  Badge,
  Chip,
} from "@mui/material";
import { Stack } from "@mui/system";
import Switch from "@mui/material/Switch";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import { useDispatch, useSelector } from "react-redux";
import { createChallengeAction } from "../../redux/toolkit/challenge/createChallenge";
import { getChallengeMissionAction } from "../../redux/toolkit/challenge/getChallengeMission.";
import { getCategoryAction } from "../../redux/toolkit/category/getCategory";
import { getSubCategoryAction } from "../../redux/toolkit/sub-category/getSubCategory";
import { getMissionQnsAction } from "../../redux/toolkit/mission/getMissionQns";
import { getAllLifeLineAction } from "../../redux/toolkit/lifeLine/allLifeLine";
import { uplodImageAction } from "../../redux/toolkit/image/uplodImage";
import JoditEditor from "jodit-react";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>

      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/allChallenge"
      >
        All Challenge
      </Link>

      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/createChallenge"
      >
        Create Challenge
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Create Challenge
    </Typography>
  </Stack>
);

const qns_ans_schema = yup
  .object()
  .shape({
    // cat_name: yup.string().required("Category is required."),
    // sub_cat_name: yup.string().required("Sub category is required."),
    // challenge_name: yup.string().required("Challenge Name Is Required."),
    // // mission_ids: yup.array().required("mission Is Required."),
    // reward: yup.number().positive().required("reward Is Required."),
    // attempt: yup.number().positive().required("Attempt Is Required."),
    // description: yup.string().required("Description Is Required."),
    // duration: yup.number().required("Duration Is Required..."),
    // flip_question: yup.string().required("Enter the Flip Question..."),
  })
  .required();

const CreateChallenge = () => {
  const dispatch = useDispatch();
  const [snack, setSnack] = useState(false);
  const [active, setIsActive] = useState(false);
  const navigate = useNavigate();
  const [selectedMissions, setSelectedMissions] = useState([]);
  const [selectedLifeline, setSelectedLifeline] = useState([]);
  console.log("selectedLifeline", selectedLifeline);

  const [howToUsePoints, setHowToUsePoints] = useState([]);
  const [newPoint, setNewPoint] = useState("");


  const [flipQuestion, setFlipQuestion] = useState("");
  console.log("flipQuestion=================>", flipQuestion);

  let cat_id = "";
  let sub_cat_id = "";
  let selected_question = "";

  const { createChallenge: data, loading } = useSelector(
    (state) => state.createChallenge
  );

  const { data: missionChallenge } = useSelector(
    (state) => state.challengeMission
  );
  const { data: missionQuestion } = useSelector((state) => state.getMissionQns);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCatategory] = useState("");
  const [lifelineEnabled, setLifelineEnabled] = useState("");
    const [isMission, setIsMission] = useState(false)
  

  const getCat = useSelector((state) => state.getCategory);
  const { data: getCatData } = getCat;

  const getSubCat = useSelector((state) => state.getSubCategory);
  const { data: getSubCatData } = getSubCat;

  const allLifeLine = useSelector((state) => state.getAllLifeLine);
  const { data: allLifelineData } = allLifeLine;

  const {
    register,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(qns_ans_schema),
    defaultValues: {},
  });
  const [image, setImage] = useState("");

  const handleImage = async (e) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (!file) return;

    formData.append("file", file);
    let FileSize = Number(file.size / 1000);

    var _URL = window.URL || window.webkitURL;
    let img = new Image();

    img.onload = async function () {
      if (FileSize > 5000) {
        return alert(
          `Image should be under 5MB. Your file size is ${FileSize.toFixed(2)}KB`
        );
      }

      try {
        let uploadedImg = await dispatch(uplodImageAction(formData));
        const imgUrl = uploadedImg?.payload?.data?.url;

        if (imgUrl) {
          setImage(imgUrl);
          setValue("image", imgUrl);
          alert(`Image uploaded successfully! File size: ${FileSize.toFixed(2)}KB`);
        }
      } catch (error) {
        alert("Error uploading image. Please try again.");
      }
    };

    img.onerror = function () {
      alert("Not a valid image file: " + file.type);
    };

    img.src = _URL.createObjectURL(file);
  };



  const handleQns = async (data) => {
    let challenge_info = {
      challenge_name: data?.challenge_name,
      mission_ids: selectedMissions,
      reward: data?.reward,
      attempt: data?.attempt,
      description: data?.description,
      duration: data?.duration,
      active: active,
      cat_id: selectedCategory,
      sub_cat_id: selectedSubCategory,
      available_lifelines: selectedLifeline,
      lifeline_enabled: lifelineEnabled,
      flip_question: flipQuestion,
      image: image,
      is_mission: isMission,
      how_to_use_points: howToUsePoints
    };

    console.log(
      "challenge_info==================================>",
      challenge_info
    );
    // return

    const createChallengeData = await dispatch(
      createChallengeAction(challenge_info)
    );
    setSnack(true);
    if (createChallengeData?.payload?.status == 201) {
      reset();
      setTimeout(() => {
        navigate("/allChallenge");
      }, 1500);
    }

    setSnack(true);
    // setState(false)
  };

  const handleSwitchChange = () => {
    setIsActive(!active);
  };
  const handleLifelineChange = () => {
    setLifelineEnabled(!lifelineEnabled);
  };

  const handleClose = function () {
    reset();
    navigate("/allChallenge");
  };

  const handleIsMissionChange = () => {
    setIsMission(!isMission);
  };


  const handleAddPoint = () => {
    if (newPoint.trim()) {
      setHowToUsePoints([...howToUsePoints, newPoint]);
      setNewPoint("");
    }
  };

  // Remove How to Use Point
  const handleRemovePoint = (index) => {
    setHowToUsePoints(howToUsePoints.filter((_, i) => i !== index));
  };

    useEffect(() => {
      dispatch(getChallengeMissionAction({ is_deleted: false, category: selectedCategory?._id, subCategory: selectedSubCategory?._id }));
    }, [dispatch,selectedCategory ,selectedSubCategory]);

  useEffect(() => {
    dispatch(getCategoryAction({ is_deleted: false }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllLifeLineAction());
  }, []);

  return (
    <>
      <Helmet>
        <title> Create Challenge</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      {/* <DrawerUI /> */}
      <Body>
        {/* <Card sx={{ width: 500, p: 5 }}> */}
        <Card sx={{ p: 5 }}>
          <Typography variant="h5" sx={{ mb: 5 }}>
            Add Challenge
          </Typography>
          <form onSubmit={handleSubmit(handleQns)}>
            <Stack spacing={3}>
              <Stack direction="row" spacing={10}>
                <Autocomplete
                  disablePortal
                  options={getCatData || []}
                  value={selectedCategory || null}
                  getOptionLabel={(option) => option?.cat_name || ""}
                  onChange={(event, value) => {
                    setSelectedCategory(value);
                    setSelectedSubCatategory(null);
                    if (value?._id) {
                      dispatch(
                        getSubCategoryAction({
                          cat_id: value._id,
                          is_deleted: false,
                        })
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category Name"
                      error={!!errors?.cat_name}
                      helperText={errors?.cat_name?.message}
                      style={{ width: "450px" }}
                    />
                  )}
                />

                <Autocomplete
                  disablePortal
                  options={getSubCatData || []}
                  value={selectedSubCategory || null}
                  getOptionLabel={(option) => option?.sub_cat_name || ""}
                  onChange={(event, value) => {
                    setSelectedSubCatategory(value);
                    if (value?._id) {
                      dispatch(getMissionQnsAction({ sub_cat_id: value._id }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sub Category Name"
                      error={!!errors?.sub_cat_name}
                      helperText={errors?.sub_cat_name?.message}
                      style={{ width: "450px" }}
                    />
                  )}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <TextField
                  label="challenge_name"
                  error={errors?.challenge_name?.message}
                  helperText={errors?.challenge_name?.message}
                  {...register("challenge_name")}
                  style={{ width: "450px" }}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <Autocomplete
                  multiple
                  id="mission-challenge"
                  options={missionChallenge}
                  // show title in dropdown
                  getOptionLabel={(option) => option.title}
                  // convert ids → full objects to display correct labels
                  value={missionChallenge.filter((item) =>
                    selectedMissions.includes(item._id)
                  )}
                  onChange={(event, newValue) => {
                    const ids = newValue.map((v) => v._id);
                    setSelectedMissions(ids);
                    console.log("Selected IDs:", ids);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Missions"
                      variant="outlined"
                      style={{ width: "450px" }}
                    />
                  )}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <Autocomplete
                  multiple
                  id="selected-life-line"
                  options={allLifelineData}
                  // show title in dropdown
                  getOptionLabel={(option) => option.name}
                  // convert ids → full objects to display correct labels
                  value={allLifelineData.filter((item) =>
                    selectedLifeline.includes(item?._id)
                  )}
                  onChange={(event, newValue) => {
                    const ids = newValue.map((v) => v._id);
                    setSelectedLifeline(ids);
                    console.log("Selected IDs:", ids);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Lifeline"
                      variant="outlined"
                      style={{ width: "450px" }}
                    />
                  )}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <Autocomplete
                  disablePortal
                  id={missionQuestion?._id}
                  options={missionQuestion}
                  getOptionLabel={(missionQuestion) =>
                    missionQuestion?.question
                  }
                  onChange={(event, value) => {
                    selected_question = value

                    setFlipQuestion(selected_question?._id)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Flip Question Name"
                      error={errors?.selected_question?.message}
                      helperText={errors?.selected_question?.message}
                      {...register("selected_question")}
                      style={{ width: "450px" }}
                    />
                  )}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <TextField
                  label="reward"
                  error={errors?.reward?.message}
                  helperText={errors?.reward?.message}
                  {...register("reward")}
                  style={{ width: "450px" }}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <TextField
                  label="attempt"
                  error={errors?.attempt?.message}
                  helperText={errors?.attempt?.message}
                  {...register("attempt")}
                  style={{ width: "450px" }}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <TextField
                  label="description"
                  error={errors?.description?.message}
                  helperText={errors?.description?.message}
                  {...register("description")}
                  style={{ width: "450px" }}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <TextField
                  label="duration in Minute"
                  error={errors?.duration?.message}
                  helperText={errors?.duration?.message}
                  {...register("duration")}
                  style={{ width: "450px" }}
                />
              </Stack>
              <Stack spacing={2}>
                <Typography variant="subtitle2">Challenge Image</Typography>
                <TextField
                  type="file"
                  accept="image/*"
                  variant="outlined"
                  id="challenge-image-upload"
                  onChange={handleImage}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "450px" }}
                />
                {image && (
                  <Box>
                    <Typography variant="caption" color="success.main">
                      Current URL: {image}
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                      <img
                        src={image}
                        alt="Challenge preview"
                        style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "contain" }}
                      />
                    </Box>
                  </Box>
                )}
              </Stack>


              <Stack spacing={2}>
                <Typography variant="subtitle1">How to Use Points</Typography>
                <Stack direction="row" spacing={2}>
                  <TextField
                    label="Add Point"
                    value={newPoint}
                    onChange={(e) => setNewPoint(e.target.value)}
                    style={{ width: "380px" }}
                    InputLabelProps={{ shrink: true }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddPoint();
                      }
                    }}
                  />
                    {/* <JoditEditor
                                                          tabIndex={2}
                                                          id="short_description"
                                                          value={newPoint}
                                                          onBlur={(newContent) => {
                                                              setNewPoint(newContent);
                                                          }}
                                                          onChange={(newContent) => setNewPoint(newContent)}
                                                          onKeyPress={(e) => {
                                                              if (e.key === "Enter") {
                                                                  e.preventDefault();
                                                                  handleAddPoint();
                                                              }
                                                          }}
                  
                                                      />  */}
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleAddPoint}
                  >
                    Add
                  </Button>
                </Stack>
                <Box>
                  {howToUsePoints?.map((point, index) => (
                    <Chip
                      key={index}
                      label={point}
                      onDelete={() => handleRemovePoint(index)}
                      style={{ margin: "5px" }}
                    />
                  ))}
                </Box>
              </Stack>


              <Stack direction="row" spacing={10}>
                <FormControlLabel
                  control={
                    <Switch onChange={handleSwitchChange} checked={active} />
                  }
                  label="Is Active"
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <FormControlLabel
                  control={
                    <Switch
                      onChange={handleLifelineChange}
                      checked={lifelineEnabled}
                    />
                  }
                  label="Is Lifeline Enabled"
                />
              </Stack>


              <Stack direction="row" spacing={10}>
                <FormControlLabel
                  control={
                    <Switch
                      onChange={handleIsMissionChange}
                      checked={isMission}
                    />
                  }
                  label="Is Mission"
                />
              </Stack>

              <Stack direction="row" spacing={2}>
                <Button variant="contained" type="submit" disabled={loading}>
                  {loading ? <CircularProgress /> : "Create Challenge"}
                </Button>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Back
                </Button>
              </Stack>
            </Stack>
          </form>
        </Card>
      </Body>

      {/* <SnackBarUI
        state={snack}
        setState={setSnack}
        status={createMissionStatus}
        message={createMissionMsg}
      /> */}
    </>
  );
};

export default CreateChallenge;
